import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import logo from "../images/TP-_logo-orizz-claim-color-white-text.png";
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/amotive-logo-symbol-inverted-cut.png";
import logoInvert3 from "../images/logo_proforma-removebg-preview (1).png";
import { IoIosArrowForward } from "react-icons/io";
import { FaUnlock } from "react-icons/fa";
import { FaLock } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import logoQlik from "../images/qlik2.png";
import logoInvertTp from "../images/TP-_logo-symbol-white.png";


function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    return lockedState ? JSON.parse(lockedState) : true;
  });
  const [showMap, setShowMap] = useState(false);
  const handleShowMap = () => setShowMap(true);
  const handleCloseMap = () => setShowMap(false);



  const handleLockClick = () => {
    setIsLocked(!isLocked);
  };

  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));
  }, [isLocked]);

  useEffect(() => {
    let intervalId;

    if (!isLocked) {
      intervalId = setInterval(() => {
        window.location.reload();
      }, 150000);
    } else {
      intervalId = setInterval(() => {
        window.location.href = "/amotive";
      }, 150000);
    }

    return () => clearInterval(intervalId);
  }, [isLocked]);

  const [downloads, setDownloads] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredDownloads = downloads.filter((item) =>
    item.ragione_sociale?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  useEffect(() => {
    fetch("mancata_vendita_dashboard.json")
      .then((res) => res.json())
      .then((data) => {
        console.log("Dati ricevuti:", data);

        if (data?.TP?.download && Array.isArray(data.TP.download)) {
          setDownloads(data.TP.download); // Usa direttamente l'array
        } else {
          console.warn("Struttura download non valida:", data?.TP?.download);
        }
      })
      .catch((err) => console.error("Errore fetch:", err));
  }, []);

  return (
    <Navbar
      expand="lg"
      className="navbar-desktop full-width-navbar shadow sticky-navbar navbar-heigth m-3 rounded-pill mb-0 mt-2"
      style={{
        background: "rgb(0, 0, 0)",
        maxHeight: "50px",
        padding: "28px",
      }}
    >
      <Container fluid className="p-0">
        <Navbar.Brand
          href="#home"
          className="fs-3 fw-bold mx-3 d-flex align-items-center"
        >
          <img
            alt=""
            src={logo}
            className="d-inline-block align-middle logo"
            style={{ maxWidth: "150px" }}
          />
        </Navbar.Brand>

       

      

        <Navbar.Collapse id="navbar-responsive" className="justify-content-end">
          <div
            className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-3 py-3"
            style={{ textAlign: "left" }}
          >
            {/* MAP BUTTON */}
            {/* QLIK */}
            {/* DOWNLOAD DROPDOWN */}
            {/* BRAND LINKS */}






            <Link to="/technoparts">
              <img
                alt="Sud Ricambi"
                src={logoInvertTp}
                className="d-inline-block align-middle mb-1"
                style={{ maxWidth: "25px" }}
              />
              <span className="text-light mx-2">TECHNOPARTS</span>{" "}
            </Link>

            <Link to="/sud-ricambi">
              <img
                alt="Sud Ricambi"
                src={logoInvert}
                className="d-inline-block align-middle mb-1"
                style={{ maxWidth: "30px" }}
              />
              <span className="text-light mx-2">SUD RICAMBI</span>{" "}
            </Link>

            <Link to="/amotive">
              <img
                alt="Amotive"
                src={logoInvert2}
                className="d-inline-block align-middle mb-1 logo"
                style={{ maxWidth: "20px" }}
              />
              <span className="text-light mx-2">AMOTIVE</span>
            </Link>

            <div
              className="mx-3"
              style={{
                width: "1px",
                height: "30px",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
            ></div>

            {/* LOCK TOGGLE */}
            <div className="toggle-button-cover mt-2">
              <div id="button-3" className="button r">
                <input
                  className="checkbox"
                  type="checkbox"
                  checked={isLocked}
                  onChange={handleLockClick}
                />
                <div className="knobs"></div>
                <div className="layer"></div>
                <span className="lock-icon" isLocked={isLocked.toString()}>
                  {isLocked ? (
                    <FaUnlock className="text-dark fs-6" />
                  ) : (
                    <FaLock className="text-dark fs-6" />
                  )}
                </span>
              </div>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;
